import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/crm/opportunities')({
  component: OpportunitiesLayout,
})

function OpportunitiesLayout() {
  return <Outlet />
}
